import { render, staticRenderFns } from "./PanelTopHeader.vue?vue&type=template&id=4755014a&scoped=true&"
import script from "./PanelTopHeader.vue?vue&type=script&lang=ts&"
export * from "./PanelTopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PanelTopHeader.vue?vue&type=style&index=0&id=4755014a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755014a",
  null
  
)

export default component.exports
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QHeader,QToolbar,QToolbarTitle,QBtn,QIcon,QTooltip,QImg,QItem,QItemSection});qInstall(component, 'directives', {Ripple});
